<template>
  <nav-bar title="配置经营区域" />
  <Content :bottom="80" >
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getDataLoading" />
    <ul v-if="list.length" class="list">
      <li v-for="item in list" :key="item.rid" class="list-item">
        <div class="list-item_title">{{item.regionName}}</div>
        <van-button size="small" icon="delete-o" type="danger" @click="handleDelItem(item.rid)">删除</van-button>
      </li>
    </ul>
    <Empty v-else />
  </Content>
  <div class="fixed-btn">
    <van-button block type="primary" native-type="button" @click="popup.showPopup()" >
      添加企业经营区域
    </van-button>
  </div>
  <Popup ref="popup" title="添加企业经营区域" minHeight="100%">
    <div class="popup-content">
      <van-form @submit="onSubmit">
        <van-field name="radio" label="区域" :rules="[{ required: true, message: '请选择区域' }]">
          <template #input>
            <van-radio-group v-model="radioValue" direction="horizontal">
              <van-radio name="1">全市</van-radio>
              <van-radio name="2">区</van-radio>
              <van-radio name="3">街道</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <Picker
          v-if="radioValue === '2'"
          :require="true" text="name"
          label="所在区"
          :columns="columns"
          @confirm-values="value => (regionId = value.id)"
        />
        <Picker
          label="街道"
          :require="true"
          v-if="radioValue === '3'"
          pickerType="cascader"
          @confirm-values="value => (regionId = value)"
        />
        <div class="btn">
          <van-button round block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </Popup>
</template>

<script>
import { Toast, Dialog, Notify } from 'vant'
import { getCompanyRegionList, getRegionListByPra, isContainOtherRegion, addCompanyRegion, deleteCompanyRegion } from '@/api/companyList'
import { ref, watch } from 'vue'
import { useGetDataLoading, showLoading, isLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'DeployRegion', // 配置经营区域
  props: ['companyId'],
  setup (props) {
    // 获取经营列表
    const list = ref([])
    const { getDataLoading } = useGetDataLoading(getCompanyRegionList, (data) => {
      // console.log(data)
      list.value = data.regionList || []
    })
    getDataLoading(props.companyId)

    // 获取区列表
    const columns = ref([])
    const regionId = ref('371500000000')
    useGetData(getRegionListByPra, (data) => {
      // console.log(data)
      columns.value = data
    })(regionId.value)

    const popup = ref(null)
    const radioValue = ref('')
    watch(radioValue, (val) => {
      if (val === '1') {
        regionId.value = '371500000000'
      }
    })

    // 提交
    const onSubmit = () => {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '查询包含关系'
      })
      useGetData(isContainOtherRegion, data => {
        // console.log(data)
        Toast.clear()
        if (data === '1') {
          comfirm()
        } else if (data === '2') {
          Notify({ type: 'primary', message: '该区域或者该区域的父区域已存在，无需添加' })
        } else {
          handleAddCompanyRegion()
        }
      }, () => {
        Toast.clear()
      })({
        regionId: regionId.value,
        companyId: props.companyId
      })
    }

    // 确认弹窗 覆盖原区域
    const comfirm = () => {
      Dialog.confirm({
        title: '提示',
        message:
          '是否覆盖原区域？'
      })
        .then(() => {
          handleAddCompanyRegion()
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    }
    // 确认弹窗 删除
    const comfirmDel = (rid) => {
      Dialog.confirm({
        title: '提示',
        message:
          '确定要删除改区域？'
      })
        .then(() => {
          delItem(rid)
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    }
    // 提交企业经营区域
    const handleAddCompanyRegion = () => {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '请稍后...'
      })
      useGetData(addCompanyRegion, data => {
        Toast.clear()
        popup.value.hidePopup()
        getDataLoading(props.companyId)
      }, () => {
        Toast.clear()
      })({
        regionId: regionId.value,
        companyId: props.companyId
      })
    }

    // 删除
    const handleDelItem = (rid) => {
      comfirmDel(rid)
    }
    const delItem = (rid) => {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '请稍后...'
      })
      useGetData(deleteCompanyRegion, data => {
        Toast.clear()
        Notify({ type: 'success', message: '删除成功' })
        getDataLoading(props.companyId)
      }, () => {
        Toast.clear()
        Notify({ type: 'danger', message: '删除失败' })
      })(rid)
    }
    return { showLoading, isLoading, getDataLoading, list, popup, radioValue, columns, onSubmit, regionId, handleDelItem }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px;
  font-size: 14px;
  .list-item {
    padding: 5px;
    display: flex;
    align-items: center;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-top: 10px;
    &_title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
.btn {
  margin: 16px;
}
.popup-content {
  font-size: 14px;
  padding: 16px;
}
.fixed-btn {
  position: absolute;
  height: 80px;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  align-items: center;
}
</style>
